import { CheveronDownIcon } from '@wkda/icons';
import cx from 'classnames';
import { useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function UserNavMenu(_ref) {
  let {
    LinkComponent = 'a',
    navList,
    className
  } = _ref;
  const [openedTitles, setOpenedTitles] = useState([]);
  function toggleDropDown(title) {
    const index = openedTitles.indexOf(title);
    setOpenedTitles(index < 0 ? openedTitles.concat(title) : [...openedTitles.slice(0, index), ...openedTitles.slice(index + 1)]);
  }
  function wrapWithLink(link, children) {
    return link && LinkComponent ? /*#__PURE__*/_jsx(LinkComponent, {
      className: "wa-nav-user__item-link",
      href: link,
      children: children
    }) : children;
  }
  function renderList(_ref2, key) {
    let {
      title = '',
      items,
      link = '',
      separator
    } = _ref2;
    let level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    const itemHasDropdown = items != null && items.length > 0;
    const isOpened = openedTitles.indexOf(title) > -1;
    if (separator) {
      return /*#__PURE__*/_jsx("li", {
        className: "wa-nav-user__item-separator"
      }, "separator-" + key);
    }
    return /*#__PURE__*/_jsx("li", {
      className: cx('wa-nav-user__item'),
      children: wrapWithLink(link, /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs("div", {
          className: cx('wa-nav-user__item-wrapper', "wa-nav-user__item-wrapper--level-" + level, {
            'wa-nav-user__item-wrapper--has-dropdown': itemHasDropdown,
            'wa-nav-user__item-wrapper--active': isOpened
          }),
          onClick: itemHasDropdown ? () => toggleDropDown(title) : undefined,
          children: [/*#__PURE__*/_jsx("div", {
            className: "wa-nav-user__item-title",
            onClick: itemHasDropdown ? () => toggleDropDown(title) : undefined,
            children: title
          }, "item-title"), itemHasDropdown && /*#__PURE__*/_jsx(CheveronDownIcon, {
            className: cx('wa-nav-user__chevron', {
              'wa-nav-user__chevron--is-open': isOpened
            })
          })]
        }, "title-wrapper"), itemHasDropdown && isOpened && /*#__PURE__*/_jsx("ul", {
          className: "wa-nav-user__list",
          children: (items ?? []).map((item, index) => renderList(item, index, level + 1))
        }, "item-sublist")]
      }))
    }, key);
  }
  return /*#__PURE__*/_jsx("div", {
    className: cx('wa-nav-user', className),
    children: /*#__PURE__*/_jsx("ul", {
      className: "wa-nav-user__list",
      children: navList.map((item, index) => renderList(item, index))
    })
  });
}